(function(app) {

    app.provider("taxQualificationApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function (taxQualificationId) {
                            return crmApiGateway.get("/TaxQualifications/" + taxQualificationId);
                        }

                        service.getTaxQualifications = function() {
                            return crmApiGateway.getArray("/TaxQualifications");
                        }

                        service.update = function(taxQualificationId, taxQualification) {
                            return crmApiGateway.put("/TaxQualifications/" + taxQualificationId, taxQualification);
                        };

                        service.create = function(taxQualification) {
                            return crmApiGateway.post("/TaxQualifications", taxQualification);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line